// PET NOVA — comportamiento compartido de las secciones propias (prefijo pn-)
(function () {
  if (window.__pnInit) return;
  window.__pnInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLeashProgress() {
    var fill = document.getElementById('pnLeashFill');
    if (!fill) return;
    var LEN = 2000;
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? Math.min(window.scrollY / max, 1) : 0;
      fill.style.strokeDashoffset = LEN - LEN * pct;
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initReveal() {
    var els = document.querySelectorAll('.pn-reveal');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach(function (el) { el.classList.add('pn-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pn-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initCatTilt() {
    if (reduceMotion) return;
    document.querySelectorAll('.pn-cat-card').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        card.style.transform =
          'translateY(-8px) rotateX(' + (-y * 10).toFixed(2) + 'deg) rotateY(' + (x * 10).toFixed(2) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  function initEngrave(root) {
    var tagShape = root.querySelector('.pn-tag-shape');
    var swatches = root.querySelectorAll('.pn-swatch');
    var input = root.querySelector('.pn-engrave-input');
    var out = root.querySelector('.pn-engrave-out');
    if (!tagShape && !input) return;
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('pn-active'); });
        sw.classList.add('pn-active');
        if (tagShape) tagShape.setAttribute('fill', sw.dataset.color);
      });
    });
    if (input && out) {
      input.addEventListener('input', function () {
        out.textContent = input.value.trim().toUpperCase() || out.dataset.default || '';
      });
    }
  }

  function initCompare(root) {
    var box = root.querySelector('.pn-compare-box');
    var clip = root.querySelector('.pn-compare-clip');
    var handle = root.querySelector('.pn-compare-handle');
    if (!box || !clip || !handle) return;

    var dragging = false;
    var boxRect = null; // cacheado al iniciar el arrastre; evita reflow en cada movimiento
    var pendingPct = null;
    var rafId = null;

    var paint = function () {
      rafId = null;
      if (pendingPct === null) return;
      var pct = pendingPct;
      clip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    };

    var queueCompare = function (clientX) {
      if (!boxRect) return;
      var pct = ((clientX - boxRect.left) / boxRect.width) * 100;
      pendingPct = Math.max(4, Math.min(96, pct));
      if (rafId === null) rafId = requestAnimationFrame(paint);
    };

    handle.addEventListener('pointerdown', function (e) {
      dragging = true;
      boxRect = box.getBoundingClientRect();
      handle.setPointerCapture(e.pointerId);
    });
    window.addEventListener('pointerup', function () {
      dragging = false;
      boxRect = null;
    });
    window.addEventListener('pointermove', function (e) {
      if (dragging) queueCompare(e.clientX);
    });
    box.addEventListener('click', function (e) {
      if (e.target.closest('.pn-compare-handle')) return;
      boxRect = box.getBoundingClientRect();
      queueCompare(e.clientX);
      boxRect = null;
    });
  }

  function initProductCarousel(track) {
    var wrap = track.closest('.pn-carousel-edge-wrap') || track.parentElement;
    var prev = wrap.querySelector('[data-pn-carousel-prev]');
    var next = wrap.querySelector('[data-pn-carousel-next]');
    var scrollByAmount = function () {
      var card = track.children[0];
      if (!card) return 300;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' }); });
  }

  function initGallery(root) {
    var track = root.querySelector('[data-pn-gallery]');
    var dotsWrap = root.querySelector('[data-pn-gallery-dots]');
    if (!track || !dotsWrap) return;
    var slides = track.querySelectorAll('.pn-prod-gallery-slide');
    var dots = dotsWrap.querySelectorAll('.pn-prod-dot');
    var setActive = function () {
      var scrollLeft = track.scrollLeft;
      var idx = 0;
      var min = Infinity;
      slides.forEach(function (slide, i) {
        var d = Math.abs(slide.offsetLeft - track.offsetWidth * 0.05 - scrollLeft);
        if (d < min) { min = d; idx = i; }
      });
      dots.forEach(function (dot, i) { dot.classList.toggle('pn-active', i === idx); });
    };
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { setActive(); ticking = false; });
    });
  }

  function initProductForm(root) {
    var jsonEl = root.querySelector('.pn-variants-json');
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var pillGroups = root.querySelectorAll('[data-pn-option-pills]');
    var form = root.querySelector('[data-pn-add-form]');
    var variantInput = root.querySelector('[data-pn-variant-id]');
    var qtyInput = root.querySelector('[data-pn-quantity-input]');
    var qtyValue = root.querySelector('[data-pn-qty-value]');
    var priceEl = root.querySelector('[data-pn-price]');
    var comparePriceEl = root.querySelector('[data-pn-compare-price]');
    var addBtn = root.querySelector('[data-pn-add-btn]');
    var addLabel = root.querySelector('[data-pn-add-label]');
    var buyNowBtn = root.querySelector('[data-pn-buy-now]');
    var stockNotice = root.querySelector('[data-pn-stock-notice]');
    var stockText = root.querySelector('[data-pn-stock-text]');
    var productId = root.getAttribute('data-product-id');

    var addLabelDefault = addLabel ? addLabel.textContent : '';
    var soldOutLabel = root.querySelector('[data-pn-add-btn]') ? (addBtn.getAttribute('data-sold-out-label') || 'Agotado') : 'Agotado';
    var inStockText = stockText ? stockText.getAttribute('data-in-stock') : '';
    var outOfStockText = stockText ? stockText.getAttribute('data-out-stock') : '';

    var quantity = 1;
    var selected = [];
    pillGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-pn-option-index'), 10);
      var active = group.querySelector('.pn-prod-pill.pn-active');
      selected[idx] = active ? active.getAttribute('data-pn-option-value') : null;
    });

    function currentVariant() {
      if (!pillGroups.length) return variants[0];
      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return val == null || v.options[i] === val; });
      });
      return match || variants[0];
    }

    function broadcast(variant) {
      document.dispatchEvent(new CustomEvent('pn:variant-update', {
        detail: {
          productId: productId,
          variantId: variant.id,
          price: variant.price,
          available: variant.available,
          quantity: quantity,
          optionValue: selected.filter(Boolean).join(' · ') || null
        }
      }));
    }

    function render() {
      var variant = currentVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (comparePriceEl) {
        if (variant.comparePrice) { comparePriceEl.textContent = variant.comparePrice; comparePriceEl.style.display = ''; }
        else { comparePriceEl.style.display = 'none'; }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addLabelDefault : soldOutLabel;
      if (buyNowBtn) buyNowBtn.style.display = variant.available ? '' : 'none';
      if (stockNotice) stockNotice.classList.toggle('pn-out', !variant.available);
      if (stockText) stockText.textContent = variant.available ? inStockText : outOfStockText;
      broadcast(variant);
    }

    pillGroups.forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-pn-option-index'), 10);
      group.querySelectorAll('.pn-prod-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.pn-prod-pill').forEach(function (p) { p.classList.remove('pn-active'); });
          pill.classList.add('pn-active');
          selected[idx] = pill.getAttribute('data-pn-option-value');
          render();
        });
      });
    });

    var minus = root.querySelector('[data-pn-qty-minus]');
    var plus = root.querySelector('[data-pn-qty-plus]');
    if (minus) minus.addEventListener('click', function () {
      quantity = Math.max(1, quantity - 1);
      if (qtyValue) qtyValue.textContent = quantity;
      if (qtyInput) qtyInput.value = quantity;
      broadcast(currentVariant());
    });
    if (plus) plus.addEventListener('click', function () {
      quantity = quantity + 1;
      if (qtyValue) qtyValue.textContent = quantity;
      if (qtyInput) qtyInput.value = quantity;
      broadcast(currentVariant());
    });

    function addToCart(redirectToCheckout) {
      if (!form) return;
      var variant = currentVariant();
      if (!variant || !variant.available) return;
      var body = { id: variant.id, quantity: quantity };
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('pn:cart-updated'));
          if (redirectToCheckout) {
            window.location.href = '/checkout';
          } else {
            if (addLabel) addLabel.textContent = 'Agregado ✓';
            setTimeout(function () {
              if (addLabel) addLabel.textContent = addLabelDefault;
              if (addBtn) addBtn.disabled = !currentVariant().available;
            }, 1800);
            if (addBtn) addBtn.disabled = !currentVariant().available;
          }
        })
        .catch(function () {
          if (addBtn) addBtn.disabled = !currentVariant().available;
        });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(false);
      });
    }
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () { addToCart(true); });
    }

    render();
  }

  function initStickyBar(bar) {
    var priceEl = bar.querySelector('[data-pn-sticky-price]');
    var summaryEl = bar.querySelector('[data-pn-sticky-summary]');
    var btn = bar.querySelector('[data-pn-sticky-add]');

    document.addEventListener('pn:variant-update', function (e) {
      var d = e.detail || {};
      if (priceEl && d.price) priceEl.textContent = d.price;
      if (summaryEl) {
        var parts = [];
        if (d.optionValue) parts.push(d.optionValue);
        parts.push((d.quantity || 1) + ((d.quantity || 1) === 1 ? ' pza' : ' pzas'));
        summaryEl.textContent = parts.join(' · ');
      }
      if (btn) btn.disabled = !d.available;
    });

    if (btn) {
      btn.addEventListener('click', function () {
        var mainAddBtn = document.querySelector('[data-pn-add-btn]');
        if (mainAddBtn && !mainAddBtn.disabled) mainAddBtn.click();
      });
    }

    var buyBox = document.querySelector('[data-pn-product-form]');
    if (buyBox && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('pn-visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('pn-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(buyBox);
    } else {
      bar.classList.add('pn-visible');
    }
  }

  function initCopyCode(btn) {
    var codeEl = btn.closest('.pn-newsletter-code-box').querySelector('[data-pn-copy-code]');
    if (!codeEl) return;
    var defaultLabel = btn.getAttribute('data-copy-label') || btn.textContent;
    var copiedLabel = btn.getAttribute('data-copied-label') || defaultLabel;
    btn.addEventListener('click', function () {
      var text = codeEl.textContent.trim();
      var done = function () {
        btn.textContent = copiedLabel;
        setTimeout(function () { btn.textContent = defaultLabel; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        done();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLeashProgress();
    initReveal();
    initCatTilt();
    document.querySelectorAll('[data-pn-spotlight]').forEach(initEngrave);
    document.querySelectorAll('[data-pn-compare]').forEach(initCompare);
    document.querySelectorAll('[data-pn-carousel]').forEach(initProductCarousel);
    document.querySelectorAll('[data-pn-gallery]').forEach(function (el) { initGallery(el.closest('section')); });
    document.querySelectorAll('[data-pn-product-form]').forEach(initProductForm);
    document.querySelectorAll('[data-pn-sticky-bar]').forEach(initStickyBar);
    document.querySelectorAll('[data-pn-copy-btn]').forEach(initCopyCode);
  });
})();
